<template>
    <div class="loading-container" v-if="loading">
        <div class="lds-dual-ring"></div>
    </div>
</template>
<script>
export default {
    props: {
        loading: {
            required: true,
            type: Boolean,
            default: false
        }
    },
    mounted() {
        this.overflowBody();
    },
    watch: {
        loading(val) {
            this.overflowBody();
        }
    },
    methods: {
        overflowBody() {
            let body = document.getElementsByTagName("BODY")[0];
            if (this.loading) {
                body.style.overflow = "hidden";
            } else {
                body.style.overflow = "";
            }
        }
    }
};
</script>
<style lang="scss" scoped>
.loading-container {
    position: fixed;
    top: 0;
    width: 100%;
    height: 100vh;
    z-index: 2000;
    display: flex;
    justify-content: center;
    align-items: center;
    left: 0;
    background: #ddd;
    opacity: 0.5;
    .lds-dual-ring {
        display: inline-block;
        width: 80px;
        height: 80px;
    }
    .lds-dual-ring:after {
        content: " ";
        display: block;
        width: 40px;
        height: 40px;
        margin: 8px;
        border-radius: 50%;
        border: 6px solid #000;
        border-color: #000 transparent #000 transparent;
        animation: lds-dual-ring 1.2s linear infinite;
    }
    @keyframes lds-dual-ring {
        0% {
            transform: rotate(0deg);
        }
        100% {
            transform: rotate(360deg);
        }
    }
}
</style>
